/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmFunkcniMistoSpisovna extends GContentBase<SeznamAdmFunkcniMistoSpisovnaObj> {
        private seznamObj: SeznamAdmFunkcniMistoSpisovnaObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmFunkcniMistoSpisovnaObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmFunkcniMistoSpisovna",
                contentCaption: "jres:33000356", //RC 33000356 : Funk�n� m�sta pro spisovny
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_spi_txt}<br />{ixs_fun_txt}"
                },
                gridSettings: {
                    columnOrder: "ixs_spi_txt,ixs_fun_txt,dat_zmena,zmenu_prov_txt,ixs_ref_txt,ixs_su_txt,login"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmFunkcniMistoSpisovnaObj extends GAdmSeznamBase {
        private ixs_spi: string;

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmFunkcniMistoSpisovna", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmFunkcniMistoSpisovna",
                newRecord: isNew,
                ixs_spi: isNew == true ? ((this.ixs_spi) ? this.ixs_spi : null) : data.ixs_spi,
                ixs_fun: isNew == true ? null : data.ixs_fun
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null;
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:33000336").addField("gselectbox", Gordic.Prefabs.Select.spisspi(), {
                name: "ixs_spi",
                model: "model.ixs_spi=value.ixs_spi",
                dropdown: true,
                disabled: (this.ixs_spi) ? true : false
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.ixs_spi)
                hardFilter["ixs_spi"] = this.ixs_spi;
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.AdmFunkcniMistoSpisovna.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            this.cnt.actions.actSeznamAdmFunkcniMistoSpisovna?.update({ enabled: objArr.count > 0 })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}#{1}#".format(data.ixs_spi, data.ixs_fun),
                nazev: ""
            }
        }
    }
}